// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TargetType } from "./Shared.TargetType.gen";

export interface IDetectionZoneOccupancy {
	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	detectionZoneId: string | undefined;

	dateDetected: string | undefined;

	isOccupied: boolean;

	isOccupiedConfidence: number;

	targetType: TargetType;

	targetTypeConfidence: number;

	$type?: string | undefined;
}
export class DetectionZoneOccupancy {
	constructor(data?: IDetectionZoneOccupancy) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateDetected) { this.dateDetected = new Date(data.dateDetected); }
	}

	id: string | undefined;

	facilityId: string | undefined;

	deviceId: string | undefined;

	detectionZoneId: string | undefined;

	dateDetected: Date | undefined = new Date();

	isOccupied: boolean = false;

	isOccupiedConfidence: number = 0;

	targetType: TargetType = 0;

	targetTypeConfidence: number = 0;

	static $type: string = "CoreApi.Models.DetectionZoneOccupancy, ";
	$type?: string | undefined = DetectionZoneOccupancy.$type;
}

